module.exports = __webpack_public_path__ + "static/media/share.fe3b3af5.svg";